import React from "react";
import PropTypes from "prop-types";
import startCase from "lodash/startCase";
import {OrderFilter} from "@morningtrain/react-filters";

function ColumnHead(props) {

    const handleOnClick = () => {
        const {onClick} = props;

        if (onClick && typeof onClick === "function") {
            return onClick(...arguments);
        }
    }

    const label = props.label || startCase(props.name);
    const inner = React.Children.count(props.children) > 0 ? props.children : label;
    const sortable_slug = props.sortSlug || props.name;

    const content = (props.sortable === true) ? (<OrderFilter name={props.sortName} sortable={sortable_slug}>{inner}</OrderFilter>) : inner;

    return (
        <th title={props.title}
            align={props.alignment}
            className={props.className}
            onClick={handleOnClick}>
            {content}
        </th>
    );
}

ColumnHead.defaultProps = {
    alignment: 'left',
    sortable: true,
}

ColumnHead.propTypes = {
    label: PropTypes.node,
    name: PropTypes.string,
    title: PropTypes.string,
    className: PropTypes.string,
    alignment: PropTypes.string,
    onClick: PropTypes.func,
    sortable: PropTypes.bool,
    sortName: PropTypes.string,
    sortSlug: PropTypes.string,
}

export default ColumnHead;
